import { Link as LinkComponent, LinkProps } from 'react-router';

const Link = (props: LinkProps): JSX.Element => <LinkComponent {...props} to={props.to || {}} />;

export default Link;
